import { useEffect, useMemo, useState } from "react";

export function useSearch(query) {
  const [results, setResults] = useState([]);
  const [trendingSearches, setTrendingSearches] = useState([]);
  const [searchCategories, setSearchCategories] = useState([]);
  const value = String(query ?? "").trim();

  useEffect(() => {
    const controller = new AbortController();
    const timeout = window.setTimeout(async () => {
      try {
        const url = new URL("/search/suggestions", window.location.origin);

        if (value) {
          url.searchParams.set("q", value);
        }

        const response = await fetch(url.toString(), {
          headers: {
            Accept: "application/json",
          },
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Search request failed");
        }

        const payload = await response.json();

        setResults(Array.isArray(payload.results) ? payload.results : []);
        setTrendingSearches(
          Array.isArray(payload.trendingSearches)
            ? payload.trendingSearches
            : [],
        );
        setSearchCategories(
          Array.isArray(payload.searchCategories)
            ? payload.searchCategories
            : [],
        );
      } catch (error) {
        if (error.name !== "AbortError") {
          setResults([]);
          setTrendingSearches([]);
          setSearchCategories([]);
        }
      }
    }, 220);

    return () => {
      controller.abort();
      window.clearTimeout(timeout);
    };
  }, [value]);

  const groupedResults = useMemo(() => {
    return results.reduce((groups, item) => {
      return {
        ...groups,
        [item.type]: [...(groups[item.type] || []), item],
      };
    }, {});
  }, [results]);

  return {
    results,
    groupedResults,
    hasQuery: value.length > 0,
    trendingSearches,
    searchCategories,
  };
}
